import { ICellRendererParams } from 'ag-grid-community'
import { MessageSquare } from 'lucide-react'

import { cn } from '@/lib/ui/style-helpers'

import type { ControlRow } from '@/pages/control/ag-grid-control/types'

import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'

export const ControlCommentsCell = ({ data }: ICellRendererParams<ControlRow>) => {
  if (!data) return null

  const commentCount = data.smartQuestion?.commentCount || 0
  if (commentCount <= 0) return null

  const commentsViewed = !!data.smartQuestion?.commentsViewed

  return (
    <div className='flex h-full items-center'>
      <TextWithIcon
        text={commentCount}
        icon={<MessageSquare className='size-3' />}
        iconPosition='end'
        textClassName='text-label-small'
        className={cn(
          'h-5 min-w-5 justify-center',
          commentsViewed ? 'text-main-foreground-disabled' : 'text-main-foreground-secondary',
        )}
      />
    </div>
  )
}
